/**
 * @author: Alisa Münsterberg
 * @date: 2022-10-14
 */

/*
* Sorts the input according to the bubble sort algorithm and returns an array of all steps of the sorting process
* in the following form: [[all sortingsteps, starting with the input],[all pairs of analysed indices, starting with the first sorting step],
* [the iteration count for every step, starting with 0 for the input]]
* Example output: [[[25,41,7,18,36],[25,41,7,18,36],[25,7,41,18,36],[25,7,18,41,36],
*            [25,7,18,36,41],[7,25,18,36,41],[7,18,25,36,41],[7,18,25,36,41],[7,18,25,36,41],[7,18,25,36,41],[7,18,25,36,41]],
*            [[0,1],[1,2],[2,3],[3,4],[0,1],[1,2],[2,3],[0,1],[1,2],[0,1]],
*            [0, 0, 0, 0, 0, 1, 1, 1, 2, 2, 3]]; 
*/

function bubblesort(sortarray){
    var sortingsteps = [sortarray];
    var indices = [];
    var loopcount = [0];
    for(let n=sortarray.length-1; n>0; n--){
        const loopcounter = sortarray.length-n;
        for(let i=0;i<n;i++) {
            const temparray = JSON.parse(JSON.stringify(sortingsteps));
            const tempindices = JSON.parse(JSON.stringify(indices));  
            const temploopcount = JSON.parse(JSON.stringify(loopcount));
            if(sortarray[i+1] < sortarray[i]) {
                let j= sortarray[i+1];
                sortarray[i+1]= sortarray[i];
                sortarray[i]= j;
            }
            temparray.push(sortarray);
            tempindices.push([i,i+1]);
            temploopcount.push(loopcounter);
            sortingsteps=temparray;
            indices= tempindices;
            loopcount = temploopcount;
        }
    }
    return [sortingsteps,indices,loopcount];  
}

module.exports =  {bubblesort};